var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 35.2L22 22",
    stroke: "#00BDD6",
    strokeWidth: 2.64,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 27.5L22 22L27.5 27.5",
    stroke: "#00BDD6",
    strokeWidth: 2.64,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 35.0137C29.8961 34.6147 32.1358 33.5621 33.9722 31.972C35.8087 30.3818 37.1707 28.3158 37.9084 26.0012C38.646 23.6867 38.7307 21.2135 38.153 18.8539C37.5753 16.4944 36.3577 14.34 34.6343 12.628C32.9108 10.9161 30.7483 9.71287 28.385 9.15096C26.0216 8.58905 23.5491 8.69021 21.2395 9.4433C18.93 10.1964 16.873 11.5722 15.2952 13.4192C13.7173 15.2663 12.6798 17.5129 12.2968 19.9118C10.2746 20.1719 8.43646 21.2184 7.1805 22.8244C5.92453 24.4304 5.35193 26.4666 5.58677 28.4918C5.80904 30.3463 6.70503 32.0545 8.10441 33.2917C9.50378 34.5288 11.309 35.2086 13.1768 35.2018H16.4999",
    stroke: "#00BDD6",
    strokeWidth: 2.64,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8cc8b5266c005b00263de21dde3cb592.svg";
export { ForwardRef as ReactComponent };